const config = {
  app: {
    useFirebase: true,
    version: "1.0.29-develop",
  },
  firebaseConfig: {
    shipsCollectionName: "Ships2",
    shipTypesCollectionName: "ShipTypes2",
    parametricTablesCollectionName: "ParametricTables2",
    usersCollectionName: "Users2",
    parametricVersion: "v2",
  },
};

exports.config = config;
